import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Terminal, Transaction, Location, PayrollStatus } from '~/types';
import { Longdash } from '~/utils';
import TextField from './TextField';

export type Status =
  | Terminal['status']
  | Transaction['status']
  | Location['status']
  | PayrollStatus;

interface ColoredStatusProps {
  data: Status;
}

const ColoredStatus: FC<ColoredStatusProps> = (props) => {
  const { data } = props;
  const [t] = useTranslation('status');

  return <div className={data && `status-color__${data}`}>{data ? t(data) : Longdash}</div>;
};

interface StatusFieldProps extends ColoredStatusProps {
  addLabel?: boolean;
  label?: string;
}

const StatusField: FC<StatusFieldProps> = (props) => {
  const { addLabel = true, label, data } = props;
  const [t] = useTranslation();

  if (addLabel) {
    return (
      <TextField label={label || t('status')}>
        <ColoredStatus data={data} />
      </TextField>
    );
  }
  return <ColoredStatus data={data} />;
};

export default StatusField;
